import React from 'react';

import MetricsCard from './MetricsCard';

const EngagementMetricsPanel = ({ metrics, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card rounded-xl p-6 border border-border animate-pulse">
            <div className="h-4 bg-muted rounded w-1/2 mb-2"></div>
            <div className="h-8 bg-muted rounded w-3/4 mb-4"></div>
            <div className="h-3 bg-muted rounded w-1/3"></div>
          </div>
        ))}
      </div>
    );
  }

  const metricsData = [
    {
      title: 'Total Visitors',
      value: metrics?.totalVisitors?.toString() || '0',
      subtitle: 'Unique visitors',
      icon: 'Users',
      iconColor: 'var(--color-primary)',
      trend: 'up',
      trendValue: `${metrics?.avgVisitsPerVisitor || 0} avg visits`
    },
    {
      title: 'Total Downloads',
      value: metrics?.totalDownloads?.toString() || '0',
      subtitle: 'Media downloads',
      icon: 'Download',
      iconColor: 'var(--color-success)',
      trend: 'up',
      trendValue: `${metrics?.avgDownloadsPerVisitor || 0} per visitor`
    },
    {
      title: 'Total Views',
      value: metrics?.totalViews?.toString() || '0',
      subtitle: 'Media views',
      icon: 'Eye',
      iconColor: 'var(--color-accent)',
      trend: 'up',
      trendValue: `${metrics?.totalVisits || 0} total visits`
    },
    {
      title: 'Engagement Rate',
      value: metrics?.totalVisitors > 0 
        ? `${((metrics?.totalDownloads / metrics?.totalVisitors) * 100)?.toFixed(1)}%`
        : '0%',
      subtitle: 'Download conversion',
      icon: 'TrendingUp',
      iconColor: 'var(--color-warning)',
      trend: 'up',
      trendValue: 'Active engagement'
    }
  ];

  return (
    <div>
      <div className="mb-4">
        <h2 className="text-lg md:text-xl font-semibold mb-1">Visitor Engagement Metrics</h2>
        <p className="text-sm text-muted-foreground">Track visitor behavior and engagement across all galleries</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {metricsData?.map((metric, index) => (
          <MetricsCard key={index} {...metric} />
        ))}
      </div>
    </div>
  );
};

export default EngagementMetricsPanel;